module.exports = __webpack_public_path__ + "img/seinsmous.c36b5708.jpg";